export default __webpack_public_path__ + "static/media/Action.6d9de8aa.svg";